import { FS_FORCED_VARIATIONS, FS_IS_QA_MODE_ENABLED, QA_ASSISTANT_PROD_URL, TRUSTED_QA_ORIGINS } from '../enum/FlagshipConstant';
import { logInfoSprintf } from '../utils/utils';
import { appendScript } from './appendScript';
import { handleIframeMessage } from './messages/handleIframeMessage';
/**
 *
 * @param config
 * @returns
 */
export function loadQaAssistant(config, bundleUrl = null, visitorVariationState) {
    if (!window?.frames?.ABTastyQaAssistant) {
        logInfoSprintf(config, 'QA assistant', 'Loading QA Assistant');
        appendScript(bundleUrl || QA_ASSISTANT_PROD_URL);
    }
    let forcedVariations = {};
    const sessionForcedVariations = sessionStorage.getItem(FS_FORCED_VARIATIONS);
    try {
        forcedVariations = JSON.parse(sessionForcedVariations || '{}');
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error parsing sessionForcedVariations', error);
    }
    visitorVariationState.forcedVariations = forcedVariations;
    if (window.__flagshipSdkQaAssistantMessageHandler) {
        window.removeEventListener('message', window.__flagshipSdkQaAssistantMessageHandler);
    }
    const eventListenerMessage = (event) => {
        if (!TRUSTED_QA_ORIGINS.includes(event?.origin)) {
            return;
        }
        handleIframeMessage({
            visitorVariationState,
            event,
            config,
            func: eventListenerMessage
        });
    };
    window.__flagshipSdkQaAssistantMessageHandler = eventListenerMessage;
    window.addEventListener('message', window.__flagshipSdkQaAssistantMessageHandler);
    config.isQAModeEnabled = true;
    sessionStorage.setItem(FS_IS_QA_MODE_ENABLED, 'true');
}
